/*
  This file is there to make mocking with Vitest easier, because the glob import is tricky otherwise
*/
export * from '../../locale/*.po';
// export * from '~/locale/*.po';
